import { Controller } from "@hotwired/stimulus"

// Closes a turbo-frame modal/drawer by clearing its frame content. Default
// frame is "modal", override with data-modal-close-frame-value="drawer".
export default class extends Controller {
  static values = { frame: { type: String, default: "modal" } }
  static targets = ["panel"]

  close(event) {
    event?.preventDefault()
    const frame = document.getElementById(this.frameValue)
    if (frame) frame.innerHTML = ""
  }

  backdropClose(event) {
    // Only close when clicking on the overlay itself, not on the inner panel.
    if (this.hasPanelTarget && this.panelTarget.contains(event.target)) return
    this.close(event)
  }

  // Keyboard ESC support
  connect() {
    this._handler = (e) => { if (e.key === "Escape") this.close(e) }
    document.addEventListener("keydown", this._handler)
  }
  disconnect() {
    document.removeEventListener("keydown", this._handler)
  }
}
